import { createFileRoute } from "@tanstack/react-router";
import PrTmsAutismPage from "@/pages/PrTmsAutismPage";
export const Route = createFileRoute("/prtms-for-autism-coral-springs-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "PrTMS for Autism Spectrum Coral Springs, FL | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "EEG-guided PrTMS therapy for Autism Spectrum Disorder (ASD) in Coral Springs, FL. Non-invasive, drug-free brain wave therapy to enhance communication & calm.",
        },
        {
          property: "og:title",
          content:
            "PrTMS for Autism Spectrum Coral Springs, FL | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "EEG-guided PrTMS therapy for Autism Spectrum Disorder (ASD) in Coral Springs, FL. Non-invasive, drug-free brain wave therapy to enhance communication & calm.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/prtms-for-autism-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/prtms-for-autism-coral-springs-fl",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <PrTmsAutismPage />;
}
